import { __rest } from "tslib";
import React from 'react';
import styles from '@patternfly/react-styles/css/components/Menu/menu';
import { css } from '@patternfly/react-styles';
export const MenuBreadcrumb = (_a) => {
    var { children } = _a, props = __rest(_a, ["children"]);
    return (React.createElement("div", Object.assign({ className: css(styles.menuBreadcrumb) }, props), children));
};
MenuBreadcrumb.displayName = 'MenuBreadcrumb';
//# sourceMappingURL=MenuBreadcrumb.js.map